import { Formik } from "formik";
import * as Yup from "yup";
import React from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { initiatePayment, verifyPayment } from "src/api/payments";
import Monnify from "monnify-js";
import env from "src/config/env";
import { Button } from "../ui/button";
import { NumberFormInput } from "../widgets/FormInput";
import { useAuth } from "src/providers/AuthProvider";

const monnify = new Monnify(env.REACT_APP_MONNIFY_API_KEY, env.REACT_APP_MONNIFY_CONTRACT_CODE);

const TopUpWallet = () => {
	const { user } = useAuth();
	const queryClient = useQueryClient();

	const initialValues = {
		amount: 0,
	};
	const validationSchema = Yup.object().shape({
		amount: Yup.number().min(1000, "Amount must be a greater than N1,000").required("Amount is required"),
	});

	const { mutate: verifyMutate, isLoading: isVerifying } = useMutation(verifyPayment, {
		onSuccess: () => {
			queryClient.refetchQueries({ queryKey: ["wallet-balance"] });
		},
	});
	const { mutate: initiateMutate, isLoading: isInitiating } = useMutation(initiatePayment, {
		onSuccess: (data) => {
			monnify.initializePayment({
				...data,
				onClose: (response) => {
					if (response.status === "SUCCESS") {
						queryClient.refetchQueries({ queryKey: ["wallet-balance"] });
						verifyMutate({ reference: response.paymentReference, business_uuid: user?.business_uuid });
					}
				},
			});
		},
	});

	return (
		<Formik
			initialValues={initialValues}
			validationSchema={validationSchema}
			onSubmit={({ amount }) =>
				initiateMutate({
					transaction_type: "wallet_funding",
					business_uuid: user?.business_uuid,
					amount,
				})
			}
		>
			{({ values, setFieldValue, errors, handleSubmit }) => (
				<form onSubmit={handleSubmit} className="tw-grid tw-gap-4">
					<NumberFormInput
						className="formItem !tw-w-full"
						label="Amount to top up"
						name="amount"
						type="text"
						placeholder="Amount to top up"
						value={values.amount}
						error={errors.amount}
						onChange={(value) => setFieldValue("amount", value)}
					/>
					<Button className="tw-w-full" variant="secondary" disabled={isVerifying || isInitiating}>
						Top Up
					</Button>
				</form>
			)}
		</Formik>
	);
};

export default TopUpWallet;
